export default class AccordionContainer extends HTMLElement {
  constructor() {
    super();

    // bindings
    this.onAccordionBtnClick = this.onAccordionBtnClick.bind(this);
    this.closeAllAccordions = this.closeAllAccordions.bind(this);

    // privates
    this._node = this;
    this._accordion_btn = this._node.querySelectorAll('.accordion-btn');

    // events
    this._accordion_btn.forEach((el) => {
      el.addEventListener('click', this.onAccordionBtnClick);
    });

    // use attributes to track changes
    delete this.dataset.should_close;
  }

  /**
   * Handle accordion button click.
   */
  onAccordionBtnClick(e) {
    let btn = e.currentTarget,
        element = btn.parentElement,
        content = element.querySelector('.accordion-content'),
        inner = element.querySelector('.accordion-content-inner'),
        heights = ['0px', `${inner.getBoundingClientRect().height}px`, 'auto'];

    if (element.classList.contains('expanded')) {
      content.classList.add('no-trans');
      content.style.height = heights[1];
      content.offsetHeight;
      content.classList.remove('no-trans');
      content.style.height = heights[0];
      element.classList.remove('expanded');
      btn.setAttribute('aria-expanded', false);
    } else {
      element.classList.add('expanded');
      content.classList.add('no-trans');
      content.style.height = heights[0];
      content.offsetHeight;
      content.classList.remove('no-trans');
      content.style.height = heights[1];
      btn.setAttribute('aria-expanded', true);
    }

    content.addEventListener('transitionend', callback);

    function callback() {
      content.removeEventListener('transitionend', callback);

      if (element.classList.contains('expanded')) {
        content.style.height = heights[2];
      }
    }
  }

  /**
   * Close all accordions
   */
  closeAllAccordions() {
    this._accordion_btn.forEach((el) => {
      let element = el.parentElement,
          content = element.querySelector('.accordion-content');

      if (element.classList.contains('expanded')) {
        content.style.height = '0px';
        element.classList.remove('expanded');
      }
    });
  }

  /**
   * Observe attributes to allow communication between HTML elements
   */
  static get observedAttributes() {
    return ['data-should_close'];
  }

  /**
   * Watch for external elements wanting to close these accordions
   */
  attributeChangedCallback(name, oldValue, newValue) {
    const should_close = (name === 'data-should_close', oldValue === 'undefined', newValue === 'true');

    if (should_close) {
      this.dataset.should_close = undefined;
      this.closeAllAccordions();
    }
  }

  /**
   * Handle unmount.
   */
   disconnectedCallback() {
    this._accordion_btn.forEach((el) => {
      el.removeEventListener('click', this.onAccordionBtnClick);
    });
  }
}
